import { render, staticRenderFns } from "./Loons.vue?vue&type=template&id=c0568c96&scoped=true&"
import script from "./Loons.vue?vue&type=script&lang=js&"
export * from "./Loons.vue?vue&type=script&lang=js&"
import style0 from "./Loons.vue?vue&type=style&index=0&id=c0568c96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0568c96",
  null
  
)

export default component.exports